import { COLORS, TYPE, SPACE } from '../tokens'
import SectionLabel from '../SectionLabel'

function fmtMoney(n) {
  if (n == null) return '—'
  if (n >= 1_000_000) return `$${(n / 1_000_000).toFixed(n % 1_000_000 === 0 ? 0 : 1)}M`
  if (n >= 1_000) return `$${(n / 1_000).toFixed(0)}K`
  return `$${n.toLocaleString()}`
}

function LayerBlock({ label, limit, isPrimary }) {
  return (
    <div style={{
      background: COLORS.panelBg,
      border: `1px solid ${COLORS.hairline}`,
      borderLeft: isPrimary ? `2px solid ${COLORS.accent}` : `1px solid ${COLORS.hairline}`,
      padding: '20px 24px',
      display: 'flex', justifyContent: 'space-between', alignItems: 'baseline'
    }}>
      <span style={{ ...TYPE.body, color: COLORS.bodyText }}>{label}</span>
      <span style={{ ...TYPE.hero, color: COLORS.bodyText }}>{fmtMoney(limit)}</span>
    </div>
  )
}

function RetentionBlock({ retention }) {
  return (
    <div style={{
      background: COLORS.retentionBg,
      color: COLORS.retentionText,
      padding: '18px 24px',
      display: 'flex', justifyContent: 'space-between', alignItems: 'baseline'
    }}>
      <span style={{ ...TYPE.body }}>Self-insured retention</span>
      <span style={{ ...TYPE.hero, color: COLORS.retentionText }}>{fmtMoney(retention)}</span>
    </div>
  )
}

function Particulars({ term, review }) {
  const rows = [
    ['Effective', term?.effective_date || review?.effective_date || '—'],
    ['Expires', term?.expiration_date || review?.expiration_date || '—'],
    ['Waiting period', review?.waiting_period_hours != null ? `${review.waiting_period_hours}h` : '—'],
    ['Layers', term?.layer_type === 'portfolio' ? 'Stacked program' : 'Single carrier'],
    ['Prompt version', review?.prompt_version || '—']
  ]
  return (
    <div style={{ paddingLeft: '32px' }}>
      <SectionLabel>Program particulars</SectionLabel>
      <dl style={{ margin: 0 }}>
        {rows.map(([k, v]) => (
          <div key={k} style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: `1px solid ${COLORS.hairline}` }}>
            <dt style={{ ...TYPE.supporting, color: COLORS.mutedText }}>{k}</dt>
            <dd style={{ ...TYPE.supporting, color: COLORS.bodyText, margin: 0 }}>{v}</dd>
          </div>
        ))}
      </dl>
    </div>
  )
}

export default function CoverageStructure({ term, review }) {
  const perEvent = review?.coverage_limit_per_event
  const aggregate = review?.coverage_limit_aggregate
  const retention = review?.retention

  return (
    <section style={{ maxWidth: SPACE.sectionMaxWidth, margin: '0 auto' }}>
      <SectionLabel>Coverage structure</SectionLabel>
      <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: '32px', alignItems: 'start' }}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
          <LayerBlock label="Aggregate limit" limit={aggregate} isPrimary />
          {perEvent != null && perEvent !== aggregate && (
            <LayerBlock label="Per-event limit" limit={perEvent} />
          )}
          <RetentionBlock retention={retention} />
        </div>
        <Particulars term={term} review={review} />
      </div>
    </section>
  )
}
